import { render, staticRenderFns } from "./DealFileUpload.vue?vue&type=template&id=073ff1a2&scoped=true&"
import script from "./DealFileUpload.vue?vue&type=script&lang=js&"
export * from "./DealFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./DealFileUpload.vue?vue&type=style&index=0&id=073ff1a2&scoped=true&lang=css&"
import style1 from "./DealFileUpload.vue?vue&type=style&index=1&id=073ff1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ff1a2",
  null
  
)

export default component.exports